import { render, staticRenderFns } from "./AddressInput.vue?vue&type=template&id=2c5eaa87"
import script from "./AddressInput.vue?vue&type=script&lang=js"
export * from "./AddressInput.vue?vue&type=script&lang=js"
import style0 from "./AddressInput.vue?vue&type=style&index=0&id=2c5eaa87&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports